import React from 'react';
import LoginForm from './components/Form';
import { FormContainer } from './style.css';

const Login = () => {

    return (
        <FormContainer>
            <LoginForm />
        </FormContainer>
    )
}

export default Login